import classNames from 'classnames';
import { FC, memo, ReactElement, useMemo } from 'react';

import { AsyncImage } from '@gem/call/Removable/components/AsyncImage/AsyncImage';
import {
  AvatarTypes,
  TAvatarBackgroundColorIndex,
  BaseAvatar,
  BaseAvatarTextContent,
} from '@gem/ui-kit';

import styles from './Avatar.styles.m.css';
import { getAvatarUrlByType } from './Avatar.utils';

export { AvatarTypes };
export type { TAvatarBackgroundColorIndex };

interface IAvatarProps {
  className?: string;
  avatarClassName?: string;
  url?: string | null;
  type: AvatarTypes;
  isOnline?: boolean;
  hasLockIcon?: boolean;
  children?: ReactElement;
  title?: string | null;
  backgroundColorIndex?: TAvatarBackgroundColorIndex | null;
}

export const Avatar: FC<IAvatarProps> = memo((props) => {
  const {
    type,
    url,
    className,
    avatarClassName,
    title,
    backgroundColorIndex,
    children,
    isOnline,
    hasLockIcon,
  } = props;

  const avatarImageClassName = classNames(styles.avatarImage, avatarClassName);

  const resizedUrl = useMemo(() => url && getAvatarUrlByType(type, url), [url, type]);

  const textContent = children || (
    <BaseAvatarTextContent
      className={avatarClassName}
      type={type}
      backgroundColorIndex={backgroundColorIndex}
      title={title}
    />
  );

  return (
    <BaseAvatar
      type={type}
      className={className}
      url={url}
      hasLockIcon={hasLockIcon}
      isOnline={isOnline}
    >
      {resizedUrl ? (
        <AsyncImage
          className={avatarImageClassName}
          src={resizedUrl}
          alt=""
        >
          {textContent}
        </AsyncImage>
      ) : (
        textContent
      )}
    </BaseAvatar>
  );
});
